<template>
  <b-row class="justify-content-md-center m-0">
    <b-col lg="8">
      <base-bread-crumb :items="breadcrumbs" />

      <div v-if="learningUnit" class="h5 display-4 font-weight-bold mb-3 header__lu-title">
        {{ learningUnit.name }}
      </div>

      <div v-if="section" class="my-3 text-dark">
        {{ formatedDatetime(section.start_at, 'MMM D, YYYY') }} -
        {{ formatedDatetime(section.end_at, 'MMM D, YYYY') }}
      </div>

      <!-- Button "Back To previous page" -->
      <div>
        <b-button
          variant="outline-primary"
          class="mb-4 btn__previous-page"
          @click="gotoPreviousPage()"
        >
          Back to previous page
        </b-button>
      </div>

      <div v-if="fetching" class="d-flex justify-content-center p-4 m-3">
        <b-spinner label="Loading..." variant="dark" />
      </div>

      <b-row v-else class="mb-5">
        <b-col cols="12" lg="8">
          <DirectMessage
            v-if="learner && authUser && channel"
            :channel-url="channelUrl"
            :user="authUser"
            :learner="learner"
            :mode="directMessageMode"
            :always-display="3"
          >
            <template #header-right>
              <base-avatar-user-group
                :users="allChannelMembers"
                :limit="2"
                class="d-block d-lg-none"
              >
              </base-avatar-user-group>
            </template>
          </DirectMessage>
        </b-col>
        <b-col cols="12" lg="4" class="d-none d-lg-block">
          <CardMember v-if="channel" :channel="channel" />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { BaseBreadCrumb } from '@/components/base-components';
import { channelMixin } from '@/mixins/channelMixin';
import { datetimeMixin } from '@/mixins/datetimeMixin';
import LearningUnit from '@/models/LearningUnit';
import Section from '@/models/Section';
import Channel from '@/models/Channel';
import Learner from '@/models/Learner';
import User from '@/models/User';
import DirectMessage from './components/DirectMessage';
import CardMember from './components/CardMember';
import BaseAvatarUserGroup from '@/components/base-components/BaseAvatarUserGroup';

export default {
  name: 'PageMessageDirect',

  components: {
    BaseBreadCrumb,
    DirectMessage,
    CardMember,
    BaseAvatarUserGroup
  },

  mixins: [channelMixin, datetimeMixin],

  data() {
    return {
      limitAvatar: 2,
      fetching: false
    };
  },

  computed: {
    channelUrl() {
      return `direct_message_${this.learningUnitId}_${this.sectionId}_${this.learnerId}`;
    },

    channel() {
      return Channel.findChannel(this.channelUrl);
    },

    learningUnitId() {
      return Number.parseInt(this.$route.params.learningUnitId);
    },

    learningUnit() {
      return LearningUnit.find(this.learningUnitId);
    },

    sectionId() {
      return Number.parseInt(this.$route.params.sectionId);
    },

    section() {
      return Section.find(this.sectionId);
    },

    learnerId() {
      return Number.parseInt(this.$route.params.learnerId);
    },

    learner() {
      return Learner.find(this.learnerId);
    },

    authUser() {
      return User.query().first();
    },

    directMessageMode() {
      return this.learnerId != this.authUser.id ? 'teacher' : 'learner';
    },

    allChannelMembers() {
      return this.channel ? this.channel.allMembers() : [];
    },

    isLearner() {
      return this.channel ? this.channel.isLearner(this.authUser.id) : false;
    },

    breadcrumbs() {
      const { learningUnitId } = this;

      const baseBreadCrumb = this.isLearner
        ? [
            {
              key: 'user-dashboard',
              name: 'User Dashboard',
              to: {
                name: 'user-dashboard'
              }
            },
            {
              key: 'learning-feed',
              name: this.learningUnit?.name || '',
              to: {
                name: 'learning-unit/feed',
                params: {
                  sectionId: this.section?.id,
                  learningUnitId
                },
                query: {
                  tab: 'posts'
                }
              }
            }
          ]
        : [
            {
              key: 'design-and-planning',
              name: 'Design and planning',
              to: {
                name: 'design-planning'
              }
            },
            {
              key: 'learning-unit-info',
              name: this.learningUnit?.name || '',
              to: {
                name: 'design-planning/info',
                params: {
                  learningUnitId
                }
              }
            },
            {
              key: 'teaching-feed',
              name: 'Teaching feed',
              to: {
                name: 'design-planning/teaching-feed',
                params: {
                  sectionId: this.section?.id,
                  learningUnitId
                },
                query: {
                  view: 'feed',
                  tab: 'posts'
                }
              }
            }
          ];

      return [
        ...baseBreadCrumb,
        {
          key: 'direct-message',
          name: 'Direct Message',
          active: true
        }
      ];
    }
  },

  watch: {
    '$route.path': {
      immediate: true,
      handler: 'fetch'
    }
  },

  methods: {
    async fetch() {
      this.fetching = true;
      // await LearningUnit.api().fetchByLearningUnitId(this.learningUnitId);
      // await Teacher.api().fetch({ uid: this.learningUnit.uid });
      // await Learner.api().fetch({ id: this.learnerId });

      await this.$_channelMixin_loadDirectMessageChannel(
        this.learningUnitId,
        this.sectionId,
        this.learnerId
      );

      this.fetching = false;

      if (this.channel) {
        await this.channel.messagesAsRead(this.authUser.id);
      }
    },

    gotoPreviousPage() {
      Channel.deleteAll();
      if (this.$route.query.previousPath) {
        const { previousPath } = this.$route.query;

        this.$router.push({ path: previousPath });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
